import { render, staticRenderFns } from "./Polkadot.vue?vue&type=template&id=1fad02c6&"
import script from "./Polkadot.vue?vue&type=script&lang=js&"
export * from "./Polkadot.vue?vue&type=script&lang=js&"
import style0 from "./Polkadot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports